import moment from 'moment';
import { FirebaseUser, FirebaseUserWithData } from '../types/types';

export const expired = (user: FirebaseUserWithData | FirebaseUser) =>
  moment(user.trialExpiration).isSameOrBefore(moment(), 'days');
